var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 29,
    fill: "none",
    viewBox: "0 0 11 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#353535",
    d: "M5.276 0C4.056 0 3.07 1.032 3.07 2.305c0 1.272.987 2.304 2.206 2.304 1.217 0 2.205-1.032 2.205-2.304C7.48 1.03 6.493 0 5.276 0ZM2.839 5.2C1.278 5.2 0 6.522 0 8.15v7.147c0 .556.42 1.008.953 1.008.533 0 .965-.452.965-1.008V8.854h.492l.012 17.929c0 .746.58 1.352 1.294 1.352.715 0 1.293-.606 1.293-1.352v-10.41h.532v10.41c0 .746.579 1.352 1.294 1.352.715 0 1.299-.606 1.299-1.352V8.853h.498v6.445c0 .556.433 1.008.965 1.008.534 0 .954-.452.954-1.008V8.15c0-1.63-1.279-2.951-2.84-2.951H2.84Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.3d5174b0af8bb1c271a195a74397857d.svg";
export { ForwardRef as ReactComponent };